import type { IconComponent } from '@alltrails/denali/components/Icon';
import Backpacking from '@alltrails/denali/icons/Backpacking';
import BikingMtn from '@alltrails/denali/icons/BikingMtn';
import BikingRoad from '@alltrails/denali/icons/BikingRoad';
import BikingTouring from '@alltrails/denali/icons/BikingTouring';
import BirdWatching from '@alltrails/denali/icons/BirdWatching';
import Camping from '@alltrails/denali/icons/Camping';
import Fishing from '@alltrails/denali/icons/Fishing';
import Hiking from '@alltrails/denali/icons/Hiking';
import Horseback from '@alltrails/denali/icons/Horseback';
import Kayaking from '@alltrails/denali/icons/Kayaking';
import Ohv from '@alltrails/denali/icons/Ohv';
import RockClimbing from '@alltrails/denali/icons/RockClimbing';
import Running from '@alltrails/denali/icons/Running';
import RunningTrail from '@alltrails/denali/icons/RunningTrail';
import ScenicDriving from '@alltrails/denali/icons/ScenicDriving';
import SkiingCrossCountry from '@alltrails/denali/icons/SkiingCrossCountry';
import SkiingDownhill from '@alltrails/denali/icons/SkiingDownhill';
import Snowshoeing from '@alltrails/denali/icons/Snowshoeing';
import ViaFerrata from '@alltrails/denali/icons/ViaFerrata';
import Walking from '@alltrails/denali/icons/Walking';
import type TrailActivityType from '@alltrails/trails/types/TrailActivityType';

// Activity chip icons for the filters modal. Local map (explore-service
// does not depend on @alltrails/stats) covering the activity values the explore filter offers.
const icons: Partial<Record<TrailActivityType, IconComponent>> = {
  backpacking: Backpacking,
  'bike-touring': BikingTouring,
  birding: BirdWatching,
  camping: Camping,
  'cross-country-skiing': SkiingCrossCountry,
  fishing: Fishing,
  hiking: Hiking,
  'horseback-riding': Horseback,
  'mountain-biking': BikingMtn,
  'off-road-driving': Ohv,
  'paddle-sports': Kayaking,
  'road-biking': BikingRoad,
  'rock-climbing': RockClimbing,
  running: Running,
  'scenic-driving': ScenicDriving,
  skiing: SkiingDownhill,
  snowshoeing: Snowshoeing,
  'trail-running': RunningTrail,
  'via-ferrata': ViaFerrata,
  walking: Walking
};

const getActivityIcon = (activity: TrailActivityType): IconComponent | undefined => icons[activity];

export default getActivityIcon;
